import React, { useEffect, useState } from "react";
import DifficultyChart from "./DifficultyChart";

function AdaptiveEvalutionGraph({
  studentMarksDetails,
  setOpenGraphPopup,
  chartData,
  studentResultData,
  assessmentisAdaptive,
}) {
  const studentData = JSON.parse(localStorage.getItem("breathForStudent"));

  const cumulativeValues = [];
  let runningTotal = 0;

  studentResultData?.results?.forEach((res) => {
    const obtained = res?.obtained_marks ?? 0;
    runningTotal += obtained;
    cumulativeValues.push(runningTotal);
  });

  const checkScoreStatus = (res) => {
    const q = res?.question_response?.question;
    if (!q) return "wrong";

    const obtained = res?.obtained_marks ?? 0;
    const correctScore = q?.correct_score ?? 0;

    if (obtained === 0) return "wrong";
    if (obtained === correctScore) return "correct";
    if (obtained > 0 && obtained < correctScore) return "partial";
    return "wrong";
  };

  const chartDatas = {
    labels: chartData?.map((item) => item.questionNumber),
    values: assessmentisAdaptive
      ? studentResultData?.difficulty_history?.map((item) => item.ability) || []
      : cumulativeValues,
    isCorrect: assessmentisAdaptive
      ? studentResultData?.difficulty_history?.map((item) =>
        item.isCorrect ? "correct" : "wrong"
      )
      : studentResultData?.results?.map((res) => checkScoreStatus(res)),
    data: studentResultData?.results.map((item) => item?.question_response),
    isDescriptive: studentResultData?.results.map(
      (item) => item?.question_response?.question?.type?.type === "descriptive"
    ),
    teacherComments: studentResultData?.results.map((item) => item?.comment),
  };

  const [scores, setScores] = useState({
    VE: { correct: 0, wrong: 0, partial: 0 },
    E: { correct: 0, wrong: 0, partial: 0 },
    M: { correct: 0, wrong: 0, partial: 0 },
    H: { correct: 0, wrong: 0, partial: 0 },
    VH: { correct: 0, wrong: 0, partial: 0 },
    None: { correct: 0, wrong: 0, partial: 0 },
  });

  useEffect(() => {
    function populateCorrectWrongCount() {
      let updatedScores = {
        VE: { correct: 0, wrong: 0, partial: 0 },
        E: { correct: 0, wrong: 0, partial: 0 },
        M: { correct: 0, wrong: 0, partial: 0 },
        H: { correct: 0, wrong: 0, partial: 0 },
        VH: { correct: 0, wrong: 0, partial: 0 },
        None: { correct: 0, wrong: 0, partial: 0 },
      };

      if (assessmentisAdaptive) {
        // ✅ Adaptive case: difficulty_history with isCorrect
        studentResultData?.difficulty_history?.forEach((item) => {
          const difficulty = item.difficulty;
          const isCorrect = item.isCorrect;

          switch (difficulty) {
            case 1:
              updatedScores.VE.correct += isCorrect ? 1 : 0;
              updatedScores.VE.wrong += !isCorrect ? 1 : 0;
              break;
            case 2:
              updatedScores.E.correct += isCorrect ? 1 : 0;
              updatedScores.E.wrong += !isCorrect ? 1 : 0;
              break;
            case 3:
              updatedScores.M.correct += isCorrect ? 1 : 0;
              updatedScores.M.wrong += !isCorrect ? 1 : 0;
              break;
            case 4:
              updatedScores.H.correct += isCorrect ? 1 : 0;
              updatedScores.H.wrong += !isCorrect ? 1 : 0;
              break;
            case 5:
              updatedScores.VH.correct += isCorrect ? 1 : 0;
              updatedScores.VH.wrong += !isCorrect ? 1 : 0;
              break;
            case 6:
              updatedScores.None.correct += isCorrect ? 1 : 0;
              updatedScores.None.wrong += !isCorrect ? 1 : 0;
              break;
            default:
              break;
          }
        });
      } else {
        // ✅ Non-Adaptive case
        studentResultData?.results?.forEach((res) => {
          const q = res?.question_response?.question;
          if (!q || !q.difficulty_level) return;

          const diffName = q.difficulty_level.display_name;
          let key;

          switch (diffName) {
            case "Very Easy":
              key = "VE";
              break;
            case "Easy":
              key = "E";
              break;
            case "Medium":
              key = "M";
              break;
            case "Hard":
              key = "H";
              break;
            case "Difficult":
              key = "H";
              break;
            case "Very Hard":
              key = "VH";
              break;
            case "Very Difficult":
              key = "VH";
              break;
            case "None":
              key = "None";
              break;
            default:
              key = null;
          }

          if (!key) return;

          const obtained = res?.obtained_marks ?? 0;
          const correctScore = q?.correct_score ?? 0;

          if (obtained === 0) {
            updatedScores[key].wrong += 1;
          } else if (obtained === correctScore) {
            updatedScores[key].correct += 1;
          } else if (obtained > 0 && obtained < correctScore) {
            updatedScores[key].partial += 1;
          }
        });
      }
      setScores(updatedScores);
    }

    populateCorrectWrongCount();
  }, [studentResultData, assessmentisAdaptive]);

  const data = [
    {
      level: "Very Easy",
      correct: scores.VE.correct,
      incorrect: scores.VE.wrong,
      partial: scores.VE.partial,
    },
    {
      level: "Easy",
      correct: scores.E.correct,
      incorrect: scores.E.wrong,
      partial: scores.E.partial,
    },
    {
      level: "Medium",
      correct: scores.M.correct,
      incorrect: scores.M.wrong,
      partial: scores.M.partial,
    },
    {
      level: "Hard",
      correct: scores.H.correct,
      incorrect: scores.H.wrong,
      partial: scores.H.partial,
    },
    {
      level: "Very Hard",
      correct: scores.VH.correct,
      incorrect: scores.VH.wrong,
      partial: scores.VH.partial,
    },
    {
      level: "Not Set",
      correct: scores.None.correct,
      incorrect: scores.None.wrong,
      partial: scores.None.partial,
    },
  ];

  return (
    <div className="successful_create_transprant_body">
      <img
        src="/images/cross-circle3.svg"
        className=""
        style={{ position: "absolute", top: "10px", right: "11%" }}
        alt=""
        onClick={(e) => setOpenGraphPopup(false)}
      />
      <div
        className=" p-2 successful_create_container shadow"
        style={{ width: "73%", height: "90%", position: "relative" }}
      >
        <div>
          <div
            className="student-data"
            style={{
              position: "absolute",
              top: "2px",
              left: "1%",
              backgroundColor: "transparent",
            }}
          >
            {`${studentResultData?.assessment?.name}`}
          </div>
          <div className="absolute top-1 right-2">
            {!assessmentisAdaptive && (
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <span
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: "#00b050",
                    }}
                  />
                  <span style={{ fontSize: "14px" }}>Correct</span>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <span
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: "#ed7d31",
                    }}
                  />
                  <span style={{ fontSize: "14px" }}>Partial</span>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <span
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: "#c00000",
                    }}
                  />
                  <span style={{ fontSize: "14px" }}>Incorrect</span>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="my-2 successfully_create_message">
          <DifficultyChart
            data={chartDatas}
            assessmentIsAdaptive={assessmentisAdaptive}
            studentResultData={studentResultData}
          />
        </div>
        <div className="d-flex justify-content-around w-full">
          <div className="leftText">
            <div className="d-flex justify-content-between">
              <div className="leftText1">
                <span className="score">
                  {assessmentisAdaptive ? "Score: " : "Marks: "}
                </span>
              </div>
              <div className="score">
                {" "}
                {assessmentisAdaptive
                  ? studentResultData?.ability?.toFixed(2)
                  : `${studentResultData?.obtained_marks}/${studentResultData?.assessment?.total_marks}`}
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="leftText1">Total Questions:</div>
              <div className="score">
                {studentMarksDetails?.attempted_questions
                  ?.toString()
                  .padStart(2, "0")}
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="correctans">Correct: </div>
              <div className="correctans">
                {" "}
                {assessmentisAdaptive
                  ? studentResultData?.correct_count
                  : chartDatas.isCorrect.filter((item) => item === "correct")
                    .length}
              </div>
            </div>
            <div className="d-flex justify-content-between">
              {!assessmentisAdaptive && (
                <div className="partialans">Pratial:</div>
              )}
              <div className="partialans">
                {" "}
                {!assessmentisAdaptive &&
                  chartDatas.isCorrect.filter((item) => item === "partial")
                    .length}
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div className="wrongans">Wrong: </div>
              <div className="wrongans">
                {" "}
                {assessmentisAdaptive
                  ? studentResultData?.incorrect_count
                  : chartDatas.isCorrect.filter((item) => item === "wrong")
                    .length}
              </div>
            </div>
          </div>
          <div className="rightText">
            <table className="difficulty-table">
              <thead>
                <tr style={{ textAlign: "center" }}>
                  <th style={{ color: "#800080" }}>Difficulty Level</th>
                  <th style={{ color: "#00b050" }}>Correct</th>
                  {!assessmentisAdaptive && (
                    <th style={{ color: "#ed7d31" }}>Partial</th>
                  )}{" "}
                  <th style={{ color: "#c00000" }}>Incorrect</th>
                </tr>
              </thead>
              <tbody style={{ textAlign: "center" }}>
                {data.map((row, index) => (
                  <tr key={index}>
                    <td className="rightText1">{row.level}</td>
                    <td className="correctans">{row.correct}</td>
                    {!assessmentisAdaptive && (
                      <td className="partialans">{row.partial}</td>
                    )}{" "}
                    <td className="wrongans">{row.incorrect}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* <button onClick={() => setRecordAnswer(!recordAnswer)}></button> */}
        </div>
      </div>
    </div>
  );
}

export default AdaptiveEvalutionGraph;
